import { render, staticRenderFns } from "./UnfinishedDrafts.vue?vue&type=template&id=5434043a&scoped=true&"
import script from "./UnfinishedDrafts.vue?vue&type=script&lang=js&"
export * from "./UnfinishedDrafts.vue?vue&type=script&lang=js&"
import style0 from "./UnfinishedDrafts.vue?vue&type=style&index=0&id=5434043a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5434043a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
